module.exports = __webpack_public_path__ + "static/media/Other Data Types.9ac8ca96.png";